import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { CKEditorModule } from 'ng2-ckeditor';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbActiveModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { JwtModule } from '@auth0/angular-jwt';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FullComponent } from './components/layout/full/full.component';
import { HomeComponent } from './components/pages/home/home.component';
import { TokenInterceptor } from './helpers/token.interceptor';
import { HeaderComponent } from './components/layout/header/header.component';
import { SidebarComponent } from './components/layout/sidebar/sidebar.component';
import { DatePipe, DecimalPipe, registerLocaleData } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { ToastrInterceptor } from './helpers/toastr.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SpinnerComponent } from './components/ui/spinner/spinner.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DataTablesModule } from 'angular-datatables';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { GoogleLoginComponent } from './authentication/googlelogin/googlelogin.component';
import { BreadcrumbComponent } from './components/layout/breadcrumb/breadcrumb.component';

/* D.A.M */
import { ImmaginiComponent } from './components/pages/dam/immagini/immagini.component';
import { GallerieComponent } from './components/pages/dam/gallerie/gallerie.component';
import { DocumentiComponent } from './components/pages/dam/documenti/documenti.component';

/* Store  */
import { StoreComponent } from './components/pages/store/store/store.component';

/* Appuntamenti */

/* Prenota e ritira */

/* Pagine custom */

/* Header */
import { HeaderEntityComponent } from './components/pages/header-entity/header-entity/header-entity.component';

/* Footer */
import { FooterEntityComponent } from './components/pages/footer-entity/footer-entity/footer-entity.component';

/* Subfooter */
import { SubfooterComponent } from './components/pages/subfooter/subfooter.component';

/* Admin */
import { UserComponent } from './components/pages/admin/user/user.component';
import { SupervisoriComponent } from './components/pages/admin/supervisori/supervisori.component';
import { SimComponent } from './components/pages/clickandcollect/sim/sim.component';
import { SmartphoneComponent } from './components/pages/clickandcollect/smartphone/smartphone.component';
import { AppointmentComponent } from './components/pages/appointment/appointment/appointment.component';
import { TopicManagementComponent } from './components/pages/appointment/topic-management/topic-management.component';
import { AppointmentTimesComponent } from './components/pages/appointment/appointment-times/appointment-times.component';
import { ExportCsvEmailListsComponent } from './components/pages/appointment/export-csv-email-lists/export-csv-email-lists.component';
import { CustompageComponent } from './components/pages/custompage/custompage/custompage.component';
import { ShoppingCentersComponent } from './components/pages/custompage/shopping-centers/shopping-centers.component';
import { NewsFiltersComponent } from './components/pages/custompage/news-filters/news-filters.component';
import { FloatingbarComponent } from './components/ui/floatingbar/floatingbar.component';
import { ActionConfirmComponent } from './components/ui/actionconfirm/actionconfirm.component';
import { ImmaginiCreateComponent } from './components/pages/dam/immagini/immagini-create/immagini-create.component';
import { ImmaginiEditComponent } from './components/pages/dam/immagini/immagini-edit/immagini-edit.component';
import { DndDirective } from './directives/dnd.directive';
import { ImageLoaderDirective } from './directives/image-loader.directive';
import { DocumentiEditComponent } from './components/pages/dam/documenti/documenti-edit/documenti-edit.component';
import { DocumentiCreateComponent } from './components/pages/dam/documenti/documenti-create/documenti-create.component';
import { Page404Component } from './authentication/page404/page404.component';
import { PromoComponent } from './components/pages/store/promo/promo.component';
import { ProdottiComponent } from './components/pages/store/prodotti/prodotti.component';
import { GestioneorariComponent } from './components/pages/store/gestioneorari/gestioneorari.component';
import { AccessoristoreComponent } from './components/pages/store/accessoristore/accessoristore.component';
import { ContattistoremanagerComponent } from './components/pages/store/contattistoremanager/contattistoremanager.component';
import { StoreEditComponent } from './components/pages/store/store/store-edit/store-edit.component';
import { GallerieEditComponent } from './components/pages/dam/gallerie/gallerie-edit/gallerie-edit.component';
import { GallerieCreateComponent } from './components/pages/dam/gallerie/gallerie-create/gallerie-create.component';
import { HeaderEntityItemsComponent } from './components/pages/header-entity/header-entity-items/header-entity-items.component';
import { FooterEntityItemsComponent } from './components/pages/footer-entity/footer-entity-items/footer-entity-items.component';
import { StoreprenotaeritiraComponent } from './components/pages/store/storeprenotaeritira/storeprenotaeritira.component';
import { ProdottiEditComponent } from './components/pages/store/prodotti/prodotti-edit/prodotti-edit.component';
import { ProdottiCreateComponent } from './components/pages/store/prodotti/prodotti-create/prodotti-create.component';
import { PromoEditComponent } from './components/pages/store/promo/promo-edit/promo-edit.component';
import { PromoCreateComponent } from './components/pages/store/promo/promo-create/promo-create.component';
import { GestioneorariEditComponent } from './components/pages/store/gestioneorari/gestioneorari-edit/gestioneorari-edit.component';
import { AccessoristoreEditComponent } from './components/pages/store/accessoristore/accessoristore-edit/accessoristore-edit.component';
import { AccessoristoreCreateComponent } from './components/pages/store/accessoristore/accessoristore-create/accessoristore-create.component';
import { OpeningclosinghoursTableComponent } from './components/ui/openingclosinghours-table/openingclosinghours-table.component';
import { SpecialopeninghoursComponent } from './components/ui/specialopeninghours/specialopeninghours.component';
import { SpecialclosinghoursComponent } from './components/ui/specialclosinghours/specialclosinghours.component';
import { LoadImageFromDamComponent } from './components/ui/load-image-from-dam/load-image-from-dam.component';
import { HeaderEntityCreateComponent } from './components/pages/header-entity/header-entity-create/header-entity-create.component';
import { HeaderEntityEditComponent } from './components/pages/header-entity/header-entity-edit/header-entity-edit.component';
import { FooterEntityCreateComponent } from './components/pages/footer-entity/footer-entity-create/footer-entity-create.component';
import { FooterEntityEditComponent } from './components/pages/footer-entity/footer-entity-edit/footer-entity-edit.component';
import { HeaderEntityItemsCreateComponent } from './components/pages/header-entity/header-entity-items-create/header-entity-items-create.component';
import { HeaderEntityItemsEditComponent } from './components/pages/header-entity/header-entity-items-edit/header-entity-items-edit.component';
import { FooterEntityItemsCreateComponent } from './components/pages/footer-entity/footer-entity-items-create/footer-entity-items-create.component';
import { FooterEntityItemsEditComponent } from './components/pages/footer-entity/footer-entity-items-edit/footer-entity-items-edit.component';
import { SubfooterCreateComponent } from './components/pages/subfooter/subfooter-create/subfooter-create.component';
import { SubfooterEditComponent } from './components/pages/subfooter/subfooter-edit/subfooter-edit.component';
import { DndListDirective } from './directives/dnd-list.directive';
import { UserCreateComponent } from './components/pages/admin/user/user-create/user-create.component';
import { UserEditComponent } from './components/pages/admin/user/user-edit/user-edit.component';
import { SupervisoriCreateComponent } from './components/pages/admin/supervisori/supervisori-create/supervisori-create.component';
import { SupervisoriEditComponent } from './components/pages/admin/supervisori/supervisori-edit/supervisori-edit.component';
import { SimViewComponent } from './components/pages/clickandcollect/sim/sim-view/sim-view.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { SmartphoneViewComponent } from './components/pages/clickandcollect/smartphone/smartphone-view/smartphone-view.component';
import { TopicManagementCreateComponent } from './components/pages/appointment/topic-management/topic-management-create/topic-management-create.component';
import { TopicManagementEditComponent } from './components/pages/appointment/topic-management/topic-management-edit/topic-management-edit.component';
import { ExportCsvEmailListsCreateComponent } from './components/pages/appointment/export-csv-email-lists/export-csv-email-lists-create/export-csv-email-lists-create.component';
import { ExportCsvEmailListsEditComponent } from './components/pages/appointment/export-csv-email-lists/export-csv-email-lists-edit/export-csv-email-lists-edit.component';
import { AppointmentTimesEditComponent } from './components/pages/appointment/appointment-times/appointment-times-edit/appointment-times-edit.component';
import { AppointmentViewComponent } from './components/pages/appointment/appointment/appointment-view/appointment-view.component';
import { NewsFiltersCreateComponent } from './components/pages/custompage/news-filters/news-filters-create/news-filters-create.component';
import { NewsFiltersEditComponent } from './components/pages/custompage/news-filters/news-filters-edit/news-filters-edit.component';
import { ShoppingCentersCreateComponent } from './components/pages/custompage/shopping-centers/shopping-centers-create/shopping-centers-create.component';
import { ShoppingCentersEditComponent } from './components/pages/custompage/shopping-centers/shopping-centers-edit/shopping-centers-edit.component';
import { CustompageCreateComponent } from './components/pages/custompage/custompage/custompage-create/custompage-create.component';
import { CustompageEditComponent } from './components/pages/custompage/custompage/custompage-edit/custompage-edit.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import localeIt from '@angular/common/locales/it';
import { AppointmentCalendarViewComponent } from './components/pages/appointment/appointment/appointment-calendar-view/appointment-calendar-view.component';
import { AppointmentCalendarComponent } from './components/pages/appointment/appointment/appointment-calendar/appointment-calendar.component';
import { DraggableListChipComponent } from './components/ui/draggable-list-chip/draggable-list-chip.component';
import { ImmaginiCropComponent } from './components/pages/dam/immagini/immagini-crop/immagini-crop.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { InfoLoggedUserComponent } from './components/pages/info-logged-user/info-logged-user.component';
import { ResellerComponent } from './components/pages/reseller/reseller.component';
import { ResellerCreateComponent } from './components/pages/reseller/reseller-create/reseller-create.component';
import { ResellerEditComponent } from './components/pages/reseller/reseller-edit/reseller-edit.component';
import { MultipleLoadingViewComponent } from './components/ui/multiple-loading-view/multiple-loading-view.component';
import { MassModifyComponent } from './components/ui/mass-modify/mass-modify.component';
import { ChoiceStoresModalComponent } from './components/ui/choice-stores-modal/choice-stores-modal.component';
import { ChoiceUsersModalComponent } from './components/ui/choice-users-modal/choice-users-modal.component';
import { ChoiceStoreaccessoryModalComponent } from './components/ui/choice-storeaccessory-modal/choice-storeaccessory-modal.component';
import { ChoiceProductserviceModalComponent } from './components/ui/choice-productservice-modal/choice-productservice-modal.component';
import { ChoicePromotioneventModalComponent } from './components/ui/choice-promotionevent-modal/choice-promotionevent-modal.component';
import { ChoiceInternalgalleriesModalComponent } from './components/ui/choice-internalgalleries-modal/choice-internalgalleries-modal.component';
import { ChoiceGalleriesModalComponent } from './components/ui/choice-galleries-modal/choice-galleries-modal.component';
import { ChoiceSupervisoriModalComponent } from './components/ui/choice-supervisori-modal/choice-supervisori-modal.component';
import { ChoiceHoursModalComponent } from './components/ui/choice-hours-modal/choice-hours-modal.component';
import { SpinnerTableComponent } from './components/ui/spinner-table/spinner-table.component';
import { UpdateWhatsappModalComponent } from './components/ui/update-whatsapp-modal/update-whatsapp-modal.component';
import { ChoicePositionmapModalComponent } from './components/ui/choice-positionmap-modal/choice-positionmap-modal.component';
import { DigitalcouponComponent } from './components/pages/digitalcoupon/digitalcoupon.component';
import { DigitalcouponViewComponent } from './components/pages/digitalcoupon/digitalcoupon-view/digitalcoupon-view.component';
import { DateRangeComponent } from './components/ui/date-range/date-range.component';
import { ActivityMapComponent } from './components/pages/custompage/activity-map/activity-map.component';
import { ActivityMapCreateComponent } from './components/pages/custompage/activity-map/activity-map-create/activity-map-create.component';
import { ActivityMapEditComponent } from './components/pages/custompage/activity-map/activity-map-edit/activity-map-edit.component';
import { LoadXmlComponent } from './components/pages/xml-2/load-xml/load-xml.component';
import {
  ModalResultXmlRedComponent
} from "./components/pages/custompage/modal-result-xml-red/modal-result-xml-red.component";

registerLocaleData(localeIt);



export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    GoogleLoginComponent,
    FullComponent,
    HomeComponent,
    HeaderComponent,
    SidebarComponent,
    SpinnerComponent,
    BreadcrumbComponent,
    FloatingbarComponent,
    ActionConfirmComponent,
    ImmaginiComponent,
    GallerieComponent,
    DocumentiComponent,
    UserComponent,
    SupervisoriComponent,
    SubfooterComponent,
    HeaderEntityComponent,
    FooterEntityComponent,
    StoreComponent,
    SimComponent,
    SmartphoneComponent,
    AppointmentComponent,
    TopicManagementComponent,
    AppointmentTimesComponent,
    ExportCsvEmailListsComponent,
    CustompageComponent,
    ShoppingCentersComponent,
    NewsFiltersComponent,
    ImmaginiCreateComponent,
    ImmaginiEditComponent,
    DndDirective,
    ImageLoaderDirective,
    DocumentiEditComponent,
    DocumentiCreateComponent,
    Page404Component,
    PromoComponent,
    ProdottiComponent,
    GestioneorariComponent,
    AccessoristoreComponent,
    ContattistoremanagerComponent,
    StoreEditComponent,
    GallerieEditComponent,
    GallerieCreateComponent,
    HeaderEntityItemsComponent,
    FooterEntityItemsComponent,
    StoreprenotaeritiraComponent,
    ProdottiEditComponent,
    ProdottiCreateComponent,
    PromoEditComponent,
    PromoCreateComponent,
    GestioneorariEditComponent,
    AccessoristoreEditComponent,
    AccessoristoreCreateComponent,
    OpeningclosinghoursTableComponent,
    SpecialopeninghoursComponent,
    SpecialclosinghoursComponent,
    LoadImageFromDamComponent,
    HeaderEntityCreateComponent,
    HeaderEntityEditComponent,
    FooterEntityCreateComponent,
    FooterEntityEditComponent,
    HeaderEntityItemsCreateComponent,
    HeaderEntityItemsEditComponent,
    FooterEntityItemsCreateComponent,
    FooterEntityItemsEditComponent,
    SubfooterCreateComponent,
    SubfooterEditComponent,
    DndListDirective,
    UserCreateComponent,
    UserEditComponent,
    SupervisoriCreateComponent,
    SupervisoriEditComponent,
    SimViewComponent,
    SmartphoneViewComponent,
    TopicManagementCreateComponent,
    TopicManagementEditComponent,
    ExportCsvEmailListsCreateComponent,
    ExportCsvEmailListsEditComponent,
    AppointmentTimesEditComponent,
    AppointmentViewComponent,
    NewsFiltersCreateComponent,
    NewsFiltersEditComponent,
    ShoppingCentersCreateComponent,
    ShoppingCentersEditComponent,
    CustompageCreateComponent,
    CustompageEditComponent,
    AppointmentCalendarViewComponent,
    AppointmentCalendarComponent,
    DraggableListChipComponent,
    ImmaginiCropComponent,
    InfoLoggedUserComponent,
    ResellerComponent,
    ResellerCreateComponent,
    ResellerEditComponent,
    MultipleLoadingViewComponent,
    MassModifyComponent,
    ChoiceStoresModalComponent,
    ChoiceUsersModalComponent,
    ChoiceStoreaccessoryModalComponent,
    ChoiceProductserviceModalComponent,
    ChoicePromotioneventModalComponent,
    ChoiceInternalgalleriesModalComponent,
    ChoiceGalleriesModalComponent,
    ChoiceSupervisoriModalComponent,
    ChoiceHoursModalComponent,
    SpinnerTableComponent,
    UpdateWhatsappModalComponent,
    ChoicePositionmapModalComponent,
    DigitalcouponComponent,
    DigitalcouponViewComponent,
    DateRangeComponent,
    ActivityMapComponent,
    ActivityMapCreateComponent,
    ActivityMapEditComponent,
    LoadXmlComponent,
    ModalResultXmlRedComponent
  ],
  exports: [
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    DataTablesModule,
    NgbModalModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      defaultLanguage: 'it'
    }),
    NgxSpinnerModule,
    NgbModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-left',
      preventDuplicates: false
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem('access_token');
        },
      },
    }),
    MatSidenavModule,
    MatCheckboxModule,
    CKEditorModule,
    InfiniteScrollModule,
    AutocompleteLibModule,
    AngularMultiSelectModule,
    ImageCropperModule,
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory })
  ],
  providers: [
    DatePipe,
    DecimalPipe,
    HttpClient,
    NgbActiveModal,
    { provide: LOCALE_ID, useValue: 'it-IT' },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }, // Interceptor per aggiungere e aggiornare il token
    { provide: HTTP_INTERCEPTORS, useClass: ToastrInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true } // loader interceptor
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
